"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = void 0;

var react_1 = __importStar(require("react"));

var store2_1 = __importDefault(require("store2"));

var ThemeContext_1 = require("./ThemeContext");

var ThemeProvider = function ThemeProvider(_a) {
  var children = _a.children;

  var _b = react_1.useState(""),
      theme = _b[0],
      setTheme = _b[1];

  var changeTheme = react_1.useCallback(function (theme) {
    setTheme(theme);
    store2_1.default.set("theme", theme);
    if (typeof window === "undefined") return;
    var $html = window.document.documentElement;
    $html.classList.remove("dark", "light");
    $html.classList.add(theme);
  }, []);
  react_1.useEffect(function () {
    if (typeof window === "undefined") return;
    var darkMode = window.matchMedia("(prefers-color-scheme: dark)");
    var theme = store2_1.default.get("theme");
    darkMode.addEventListener("change", function (evt) {
      changeTheme(evt.matches ? "dark" : "light");
    });
    changeTheme(theme || (darkMode.matches ? "dark" : "light"));
  }, [changeTheme]);
  return react_1.default.createElement(ThemeContext_1.ThemeContext.Provider, {
    value: {
      theme: theme,
      changeTheme: changeTheme
    }
  }, children);
};

exports.ThemeProvider = ThemeProvider;